import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { FadeIn, Chapter } from "@/components/Motion";
import { INDUSTRIES } from "@/data/content";
import {
  Accessibility,
  HeartPulse,
  Stethoscope,
  Building2,
  Landmark,
  Recycle,
  Ship,
  Network,
} from "lucide-react";

const ICONS = { Accessibility, HeartPulse, Stethoscope, Building2, Landmark, Recycle, Ship, Network };

export default function Industries() {
  return (
    <>
      <PageHero
        overline="Industries"
        lines={["Built for the businesses", "that build access"]}
        sub="ACTIVE partners exclusively with professional organisations — companies that already sell, install or specify accessibility and mobility equipment."
      />

      <section className="bg-white pb-24 sm:pb-32" data-testid="industries-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Chapter index="01" label="Who we serve" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {INDUSTRIES.map((ind, i) => {
              const Icon = ICONS[ind.icon];
              return (
                <FadeIn key={ind.name} delay={(i % 4) * 0.06}>
                  <div
                    className="group h-full rounded-2xl border border-slate-200/80 bg-[#F8F9FA] p-7 hover:border-signal/40 hover:scale-[1.01] transition-all duration-300"
                    data-testid={`industry-${ind.name.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    <Icon size={22} className="text-signal" strokeWidth={1.5} />
                    <h3 className="mt-5 font-display text-lg font-semibold tracking-tight text-slate-950">{ind.name}</h3>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{ind.text}</p>
                  </div>
                </FadeIn>
              );
            })}
          </div>
          <FadeIn delay={0.2}>
            <div className="mt-14 rounded-2xl border border-slate-200/80 bg-white p-8 sm:p-10">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">The ideal partner</p>
              <p className="mt-4 max-w-3xl text-base md:text-lg text-slate-700 leading-relaxed">
                Already sells stairlifts or accessibility products. Can survey staircases professionally. Wants better margins, differentiated technology and a factory that answers the phone.
                <span className="text-slate-950 font-medium"> Soon, AIMEASURE™ will let your team survey with nothing but a smartphone.</span>
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      <CTABand
        overline="Industries"
        lines={["Your market.", "Our platform."]}
        primary={{ to: "/contact?type=distributor", label: "Become an ACTIVE Distributor", testid: "industries-cta" }}
      />
    </>
  );
}
